import QueryGroup from './query-group.vue';
import Query from './query.vue';

export default {
  install(application) {
    application.component('yx-query-group', QueryGroup);
    application.component('yx-query', Query);
  },
};
